

























































































































































import AppDialog from 'gl-uikit/src/components/gl-dialog.vue';
import {
    CUSTOMER_DATA,
    CUSTOMER_CONTACT_DATA,
    SPEAKING_PARTNER,
    GET_COMPANIES,
    IS_SPEAKER_EDIT,
    SELECTED_COMPANY_DATA,
} from '@/store/modules/offersModule';
import offerMixins from '@/helpers/offers/offerMixin';
import SpeakerAdd from './addSpeakers.vue';

export default {
    mixins: [offerMixins],
    components: {
        AppDialog,
        SpeakerAdd,
    },
    data() {
        return {
            loading: false,
            closed: 'closed',
            speakerDialog: false,
        };
    },
    methods: {
        async remoteMethod(this: any, query: string) {
            if (query !== '') {
                this.loading = true;
                await this.$store.dispatch(GET_COMPANIES, query);
                this.loading = false;
            }
        },
        async customerValue(this: any, value: any) {
            this.$store.commit(SELECTED_COMPANY_DATA, value);
            this.$store.dispatch(CUSTOMER_DATA, value);
            this.$store.dispatch(CUSTOMER_CONTACT_DATA);
            await this.$store.dispatch(SPEAKING_PARTNER, this.offersData.customer.id);
        },

        labelComp(item: any) {
            return `${item.NOME} -
              ${item.CAP.toUpperCase()} ${item.LOCALITA.toUpperCase()}
              ${item.customerCode ? `(${item.customerCode})` : ''}`;
        },
        speakingValue(this: any, value: any) {
            this.$store.dispatch(CUSTOMER_CONTACT_DATA, value);
        },
        addSpeaking(this: any) {
            this.$store.commit(IS_SPEAKER_EDIT, false);
            this.onModal(true);
        },

        editSpeaking(this: any) {
            this.$store.commit(IS_SPEAKER_EDIT, true);
            this.onModal(true);
        },
        onModal(this: any, value: boolean) {
            this.speakerDialog = value;
        },
    },

    computed: {
        options(this: any) {
            return this.$store.getters.getCompanies(this.offersData.company);
        },
        speaking(this: any) {
            return this.$store.getters.getSpeakingPartners;
        },
        speakerLoading(this: any) {
            return this.$store.getters.getSpeakerLoading;
        },
        address(this: any) {
            return (
                `${this.offersData.customer.address.street.toUpperCase()} - ${this.offersData.customer.address.zip.toUpperCase()} ${this.offersData.customer.address.city.toUpperCase()}`
        || ''
            );
        },
    },
};
